import React from 'react';
import { Users, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

interface FriendsListProps {
  steamId: string;
  friendCount: number;
}

export function FriendsList({ steamId, friendCount }: FriendsListProps) {
  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden">
      <Link
        to={`/user/${steamId}/friends`}
        className="block p-6 relative group hover:bg-indigo-50 transition-all"
      >
        <div className="flex items-center justify-between mb-2">
          <div className="flex-grow">
            <h2 className="text-xl font-semibold text-gray-900 group-hover:text-indigo-900 transition-colors">
              Steam Friends
            </h2>
            <p className="text-sm text-gray-500 group-hover:text-indigo-600 transition-colors mt-1">
              {friendCount === 0 ? 'Private friends list' : 'Connected players'}
            </p>
          </div>
          <div className="p-2 bg-indigo-100 rounded group-hover:bg-indigo-200 transition-colors">
            <Users className="w-5 h-5 text-indigo-600" />
          </div>
        </div>
        
        <div className="flex items-center justify-between mt-3">
          <p className="text-3xl font-bold text-gray-900 group-hover:text-indigo-600 transition-colors">
            {friendCount.toLocaleString()}
          </p>
          <ArrowRight className="w-5 h-5 text-indigo-400 transform translate-x-2 opacity-0 group-hover:translate-x-0 group-hover:opacity-100 transition-all" />
        </div>
        
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-indigo-500 transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left"></div>
      </Link>
    </div>
  );
}